var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"go-to-top"},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"icon__triangle"}),_c('span',{staticClass:"icon__circle"})])}
var staticRenderFns = []

export { render, staticRenderFns }